import { defineMessages } from 'react-intl';

const messages = defineMessages({
  needsReviewCombined: {
    id: 'App.HouseholdNotifications.needsReviewCombined',
    defaultMessage:
      'Changes have been made that may impact one or more certifications. ' +
      'Certifications requiring review have been marked with a "Needs Review" label.',
  },
});

export default messages;
